import '../report.scss'

import ANTDTab from '../../../shared/antd/ANTDTab'
import report from '../container/report.container'

const Report = () => {
  const { t, handleTabChange, activeTab, tabList } = report()

  return (
    <>
      <h2 className="page-title">{t('menu_Report')}</h2>
      <ANTDTab
        size="small"
        activeKey={activeTab}
        items={tabList.map(({ Component, ...rest }) => ({
          ...rest,
          label: t(rest?.label),
          children: Component,
        }))}
        centered
        onChange={handleTabChange}
      />
    </>
  )
}

export default Report
